import React, { createContext, useContext } from "react";
import { useSprintBoard } from "../TaksHooks/useSprintBoard";

type SprintBoardContextType = ReturnType<typeof useSprintBoard>;

const SprintBoardContext = createContext<SprintBoardContextType | null>(null);

export const SprintBoardProvider = ({ children }: any) => {

    const board = useSprintBoard();

    return (
        <SprintBoardContext.Provider value={board}>
            {children}
        </SprintBoardContext.Provider>
    );
};

export const useSprintBoardContext = (): SprintBoardContextType => {

    const context = useContext(SprintBoardContext);

    if (!context) {
        throw new Error("useSprintBoardContext debe usarse dentro de SprintBoardProvider");
    }

    return context;
};